import { useState } from "react";
import { Search, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, num } from "@/lib/api";

export const ProductPicker = ({ value, onChange }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { setRes((await api.get("/products/search", { params: { q } })).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const add = (p) => { if (!value.some((v) => v.ean === p.ean)) onChange([...value, { ean: p.ean, name: p.name }]); };
  return (
    <div className="space-y-2">
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); go(); }}>
        <Input data-testid="product-search-input" placeholder="Cerca per EAN o descrizione (es. latte granarolo)" value={q} onChange={(e) => setQ(e.target.value)} />
        <Button type="submit" data-testid="product-search-button" disabled={busy || q.trim().length < 3}><Search className="h-4 w-4" /></Button>
      </form>
      {res && <div className="max-h-48 overflow-auto rounded-lg border border-slate-100" data-testid="product-search-results">
        {!res.length && <p className="p-3 text-xs text-slate-400">Nessun prodotto trovato</p>}
        {res.map((p) => (
          <button key={p.ean} type="button" data-testid={`product-result-${p.ean}`} onClick={() => add(p)} disabled={value.some((v) => v.ean === p.ean)}
            className="flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-slate-50 disabled:opacity-40">
            <span><span className="text-slate-800">{p.name}</span><span className="ml-2 font-mono text-xs text-slate-400">{p.ean}</span></span>
            <span className="text-xs text-slate-400">{num(p.lines)} righe · aggiungi</span>
          </button>))}
      </div>}
      {value.length > 0 && <div className="flex flex-wrap gap-1.5" data-testid="product-selected">
        {value.map((p) => (
          <span key={p.ean} className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2.5 py-1 text-xs text-blue-800" data-testid={`product-chip-${p.ean}`}>
            {p.name || p.ean}<span className="font-mono text-[10px] text-blue-400">{p.ean}</span>
            <button type="button" data-testid={`product-chip-remove-${p.ean}`} onClick={() => onChange(value.filter((v) => v.ean !== p.ean))}><X className="h-3 w-3" /></button>
          </span>))}
        <button type="button" className="text-xs text-slate-400 hover:text-rose-600" data-testid="product-clear" onClick={() => onChange([])}>Svuota</button>
      </div>}
    </div>
  );
};
